import * as types from './actionTypes'

export const fetchExcelTemplates = (entityId) => ({
    type: types.EXCEL_TEMPLATES_FETCH,
    entityId
})

export const fetchExcelTemplatesSuccess = (data) => ({
    type: types.EXCEL_TEMPLATES_SUCCESS,
    data
})

export const fetchExcelTemplatesFailed = () => ({
    type: types.EXCEL_TEMPLATES_FAILED
})

export const resetExcelTemplates = () => ({
    type: types.EXCEL_TEMPLATES_RESET
})

export const exportExcel = (template, documents) => ({
    type: types.EXCEL_EXPORT,
    template,
    documents
})

export const exportExcelSuccess = () => ({
    type: types.EXCEL_EXPORT_SUCCESS
})

export const exportExcelFailed = () => ({
    type: types.EXCEL_EXPORT_FAILED
})

export const deleteExcelTemplate = (template) => ({
    type: types.EXCEL_TEMPLATE_DELETE,
    template
})

export const deleteExcelTemplateSuccess = (id) => ({
    type: types.EXCEL_TEMPLATE_DELETE_SUCCESS,
    id
})

export const deleteExcelTemplateFailed = () => ({
    type: types.EXCEL_TEMPLATE_DELETE_FAILED
})

export const excelBackup = () => ({
    type: types.EXCEL_BACKUP_FETCH
})

export const excelBackupSuccess = () => ({
    type: types.EXCEL_BACKUP_SUCCESS
})

export const excelBackupFailed = () => ({
    type: types.EXCEL_BACKUP_FAILED
})

export const setExcelTemplatesOrder = (entity, order) => ({
    type: types.SET_EXCEL_TEMPLATES_ORDER,
    entity,
    order
})
